export default __webpack_public_path__ + "static/tour-de-la-terre-308ca497a9f6f4a9d0c4d4a50c742302.png";